import { createStateLoader } from '../app';
import { catalog } from '~features';

export default createStateLoader({
    setState: catalog.actions.setFilteredItems,
    clearState: catalog.actions.clearFilteredItems,
});
